import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import rangyService from '../../services/RangyService';
import StudentHighlightService from '../../services/StudentHighlightsService';
import styles from './SelectionContextMenu.scss';
import textToSpeechService from '../../services/TextToSpeechService';
import utilService from '../../services/UtilService';


class TextToSpeechPlayer extends React.PureComponent {
    static propTypes = {
        textToSpeech: PropTypes.object,
    };

    playSelection = () => {
        textToSpeechService.playSound();
    };

    pauseSound = () => {
        textToSpeechService.pauseSound();
    };

    render() {
        const { textToSpeech } = this.props;

        if (textToSpeech.isPlaying) {
            return (
                <button
                    className={styles.contextMenuButton}
                    onMouseUp={this.pauseSound}
                    onTouchEnd={this.pauseSound}
                    aria-label={t('textToSpeech.pause')}
                >
                    <i className="fa fa-pause-circle" aria-hidden="true" />
                </button>
            );
        }

        if (textToSpeech.isAudioLoaded) {
            return (
                <button
                    className={styles.contextMenuButton}
                    onMouseUp={this.playSelection}
                    onTouchEnd={this.playSelection}
                    aria-label={t('textToSpeech.play')}
                >
                    <i className="fa fa-play-circle" aria-hidden="true" />
                </button>
            );
        }

        return (
            <button
                className={styles.contextMenuButton}
                aria-label={t('textToSpeech.loading')}
            >
                <i className="fa fa-spinner fa-pulse fa-fw" aria-hidden="true" />
            </button>
        );
    }
}

class StudentHighlights extends React.PureComponent {
    static propTypes = {
        studentHighlights: PropTypes.object,
    };

    addStudentHighlight = () => {
        StudentHighlightService.addStudentHighlight();
    };

    removeHighlight = () => {
        StudentHighlightService.removeHighlight();
    };

    render() {
        const { studentHighlights } = this.props;

        if (studentHighlights.selectionInHighlight) {
            return (
                <button
                    className={styles.contextMenuButton}
                    onMouseUp={this.removeHighlight}
                    onTouchEnd={this.removeHighlight}
                    aria-label={t('highlights.removeHighlight')}
                >
                    <i className="fa fa-trash-o" aria-hidden="true" />
                </button>
            );
        }

        return (
            <button
                className={styles.contextMenuButton}
                onMouseUp={this.addStudentHighlight}
                onTouchEnd={this.addStudentHighlight}
                aria-label={t('highlights.addHighlight')}
            >
                <i className="fa fa-edit" aria-hidden="true" />
            </button>
        );
    }
}

class SelectionContextMenu extends React.PureComponent {
    static propTypes = {
        studentHighlights: PropTypes.object,
        textToSpeech: PropTypes.object,
    };

    getNativeSelection = () => {
        const rangy = rangyService.getRangy();
        const selection = rangy.getSelection();
        if (selection.toString()) {
            return selection.nativeSelection;
        }
        return undefined;
    };

    render() {
        const { studentHighlights, textToSpeech } = this.props;
        const nativeSelection = this.getNativeSelection();

        if (!nativeSelection) {
            return null;
        }

        const rect = nativeSelection.getRangeAt(0).getBoundingClientRect();
        let arrowAlignment = 'top';
        let toolTipStyle = {};
        if (rect.top < 40 || utilService.isTouchDevice()) {
            arrowAlignment = 'bottom';
            toolTipStyle = {
                top: rect.bottom + 10,
                left: rect.left,
            };
        } else {
            toolTipStyle = {
                top: rect.top - 55,
                left: rect.left,
            };
        }

        return (
            <div style={toolTipStyle} className={`${styles.toolTip} ${arrowAlignment}`}>
                {
                    studentHighlights.hasValidSelection ?
                        <StudentHighlights studentHighlights={studentHighlights} />
                        : null
                }
                {
                    textToSpeech.isEnabled && textToSpeech.hasValidSelection ?
                        <TextToSpeechPlayer textToSpeech={textToSpeech} />
                        : null
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { studentHighlights, textToSpeech } = state;
    return {
        studentHighlights,
        textToSpeech,
    };
}

const SelectionContextMenuContainer = connect(mapStateToProps)(SelectionContextMenu);
export default SelectionContextMenuContainer;
